// Shared date-range filter for the Skip report pages. Native <input
// type="date"> fields + a Refresh button — matching the Collections
// MetricsPage / WbReportsPage convention (no DatePicker component).

import { type FormEvent } from 'react';
import { RefreshCw } from 'lucide-react';
import { Card } from '../../../../components/ui/Card/Card';
import { Button } from '../../../../components/ui/Button/Button';
import { todayIsoDate } from '../../reportRunnerUtils';
import type { DateRange } from '../useSkipReports';
import styles from '../skipReports.module.css';

/** Default range used by every Skip report page: the last 30 days. */
export function lastThirtyDays(): DateRange {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - 30);
  const iso = (d: Date): string => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };
  return { date_from: iso(from), date_to: iso(to) };
}

interface DateRangeFilterProps {
  form: DateRange;
  onChange: (next: DateRange) => void;
  onSubmit: () => void;
  loading: boolean;
}

export function DateRangeFilter({
  form,
  onChange,
  onSubmit,
  loading,
}: DateRangeFilterProps): JSX.Element {
  function handleSubmit(e: FormEvent<HTMLFormElement>): void {
    e.preventDefault();
    onSubmit();
  }
  return (
    <Card>
      <form onSubmit={handleSubmit} className={styles.filters}>
        <label className={styles.dateField}>
          <span>Date from</span>
          <input
            type="date"
            value={form.date_from}
            max={form.date_to || todayIsoDate()}
            onChange={(e) => onChange({ ...form, date_from: e.target.value })}
            required
          />
        </label>
        <label className={styles.dateField}>
          <span>Date to</span>
          <input
            type="date"
            value={form.date_to}
            min={form.date_from}
            onChange={(e) => onChange({ ...form, date_to: e.target.value })}
            required
          />
        </label>
        <Button type="submit" variant="primary" icon={RefreshCw} loading={loading}>
          Refresh
        </Button>
      </form>
    </Card>
  );
}
